import { render, staticRenderFns } from "./blank-answer.vue?vue&type=template&id=28780ad1&scoped=true"
import script from "./blank-answer.vue?vue&type=script&lang=ts"
export * from "./blank-answer.vue?vue&type=script&lang=ts"
import style0 from "./blank-answer.vue?vue&type=style&index=0&id=28780ad1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28780ad1",
  null
  
)

export default component.exports